/** Return the start and end months for the calendar navigation. */
export function getNavMonths(props, dateLib) {
  var startMonth = props.startMonth,
    endMonth = props.endMonth;
  var startOfYear = dateLib.startOfYear,
    startOfDay = dateLib.startOfDay,
    startOfMonth = dateLib.startOfMonth,
    endOfMonth = dateLib.endOfMonth,
    addYears = dateLib.addYears,
    endOfYear = dateLib.endOfYear,
    newDate = dateLib.newDate,
    today = dateLib.today;
  // Handle deprecated code
  var fromYear = props.fromYear,
    toYear = props.toYear,
    fromMonth = props.fromMonth,
    toMonth = props.toMonth;
  if (!startMonth && fromMonth) {
    startMonth = fromMonth;
  }
  if (!startMonth && fromYear) {
    startMonth = dateLib.newDate(fromYear, 0, 1);
  }
  if (!endMonth && toMonth) {
    endMonth = toMonth;
  }
  if (!endMonth && toYear) {
    endMonth = newDate(toYear, 11, 31);
  }
  var hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
  if (startMonth) {
    startMonth = startOfMonth(startMonth);
  } else if (fromYear) {
    startMonth = newDate(fromYear, 0, 1);
  } else if (!startMonth && hasYearDropdown) {
    var _props$today;
    startMonth = startOfYear(addYears((_props$today = props.today) !== null && _props$today !== void 0 ? _props$today : today(), -100));
  }
  if (endMonth) {
    endMonth = endOfMonth(endMonth);
  } else if (toYear) {
    endMonth = newDate(toYear, 11, 31);
  } else if (!endMonth && hasYearDropdown) {
    var _props$today2;
    endMonth = endOfYear((_props$today2 = props.today) !== null && _props$today2 !== void 0 ? _props$today2 : today());
  }
  return [startMonth ? startOfDay(startMonth) : startMonth, endMonth ? startOfDay(endMonth) : endMonth];
}